export default "__VITE_ASSET__DlOp$HAJ__"